<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>报表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item> 油气消费报表 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-box toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="item-label">报备时间</span>
        <el-date-picker
          v-model="timeRange"
          @change="chioceTime"
          value-format="timestamp"
          type="datetimerange"
          placeholder="选择日期范围"
          :clearable="false"
          :default-time="['00:00:00', '23:59:59']"
          style="width: 380px"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="item-label">运单号</span>
        <el-input
          v-model.trim="filter.orderNumber"
          :maxlength="50"
          clearable
          placeholder="请输入运单号或预约单号"
          style="width: 200px"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">司机姓名</span>
        <el-input
          v-model.trim="filter.driverName"
          :maxlength="20"
          clearable
          placeholder="请输入司机姓名"
          style="width: 200px"
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="item-label">司机手机号</span>
        <el-input
          v-model.trim="filter.driverMobile"
          :maxlength="20"
          clearable
          placeholder="请输入司机手机号"
          style="width: 200px"
        ></el-input>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="search" id="auto-4"> 筛选</el-button>
        <el-button size="small" @click="resetSearch" id="auto-5">清除条件</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 油气消费报表 </span>
      </div>
      <div class="fr">
        <el-button type="primary" size="small" id="auto-6" :disabled="tableData.total === 0" @click="handleExport(1)"
          >导出</el-button
        >
        <el-button type="primary" size="small" id="auto-6" :disabled="tableData.total === 0" @click="handleExport(2)"
          >导出票据</el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-8">
      <el-table :data="tableData.data" border>
        <el-table-column prop="appointmentNo" label="预约单号" min-width="190" show-overflow-tooltip>
          <template v-slot="scope">
            <span class="font-green pointer" @click="handleDetail(1, scope.row.appointmentNo)">
              {{ scope.row.appointmentNo }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="运单号" min-width="150" show-overflow-tooltip>
          <template v-slot="scope">
            <span class="font-green pointer" @click="handleDetail(2, scope.row.orderNumber)">
              {{ scope.row.orderNumber }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="driverName" label="司机姓名" min-width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="driverMobile" label="司机手机号" min-width="110"> </el-table-column>
        <el-table-column prop="captainName" label="车队长姓名" min-width="100" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="carrierName" label="承运公司" min-width="150" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" min-width="100"> </el-table-column>

        <el-table-column prop="fuelExpenseLimit" label="油费消费上限(元)" min-width="130">
          <template v-slot="scope">
            <span>{{ scope.row.fuelExpenseLimit | thousands(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="totalExpenseAmount" label="累计消费金额(元)" min-width="130">
          <template v-slot="scope">
            <span>{{ scope.row.totalExpenseAmount | thousands(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="remainingAmount" label="剩余金额(元)" min-width="130">
          <template v-slot="scope">
            <span class="font-red">{{ scope.row.remainingAmount | thousands(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="20"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="dialogVisible" width="900px">
      <el-table :data="detailData" border :max-height="700">
        <el-table-column label="报备时间" prop="reportTime" min-width="150"></el-table-column>
        <el-table-column label="预计消费时间" prop="expectConsumeTime" width="150"> </el-table-column>
        <el-table-column label="预计消费金额" prop="expectConsumeMoney" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.expectConsumeMoney | thousands(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="预计加油站点"
          prop="expectOilStation"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="状态" prop="consumeStatusDesc" width="100"></el-table-column>
        <el-table-column label="实际消费时间" prop="actualConsumeTime" width="150"> </el-table-column>
        <el-table-column label="实际加油升数" prop="actualConsumeNum" width="100"> </el-table-column>
        <el-table-column label="实际消费金额" prop="actualConsumeMoney" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.actualConsumeMoney | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费小票" prop="oilFileUrl" width="100">
          <template v-slot="scope">
            <el-button
              type="text"
              class="font-size12 font-blue"
              v-if="scope.row.oilFileUrl"
              @click="showViewer(scope.row.oilFileUrl)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:8
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/report.new.api.js';
import { WUYI } from '@/api/common';
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      timeRange: [
        new Date(WUYI.time.monthfirst).getTime(),
        new Date(WUYI.time.timeend + WUYI.time.oneday - 1000).getTime()
      ],
      filter: {
        startTime: new Date(WUYI.time.monthfirst).getTime(),
        endTime: new Date(WUYI.time.timeend + WUYI.time.oneday - 1000).getTime(),
        orderNumber: '',
        driverName: '',
        driverMobile: ''
      },
      searchCache: {},
      tableData: {
        data: [],
        total: 0
      },
      dialogVisible: false,
      detailData: []
    };
  },
  created() {
    this.search();
  },
  methods: {
    chioceTime(val) {
      if (val) {
        this.filter.startTime = new Date(val[0]).getTime();
        this.filter.endTime = new Date(val[1]).getTime();
      } else {
        this.filter.startTime = '';
        this.filter.endTime = '';
      }
    },
    search() {
      if (!WUYI.checkDate(this.filter.startTime, this.filter.endTime)) return;
      this.searchCache = { ...this.filter };
      this.currentPage = 1;
      this.axiosRequest();
    },
    async handleDetail(type, number) {
      // type 1预约单号 2运单号
      this.dialogVisible = true;
      const params = type === 1 ? { appointmentNo: number } : { orderNumber: number };
      const { data } = await axios.post(api.oilgasOrderDetailList, { ...params });
      this.detailData = data || [];
    },
    showViewer(url) {
      this.$store.dispatch('showViewer', { data: [{ url: url }] });
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchCache
      };
      axios.post(api.oilgasOrderList, options).then(res => {
        this.tableData.data = res.data?.data || [];
        this.tableData.total = res.data?.total || 0;
      });
    },
    resetSearch() {
      let startTime = new Date(WUYI.time.monthfirst).getTime();
      let endTime = new Date(WUYI.time.timeend + WUYI.time.oneday - 1000).getTime();
      this.filter.startTime = startTime;
      this.filter.endTime = endTime;
      this.timeRange = [startTime, endTime];
      this.filter.orderNumber = '';
      this.filter.driverName = '';
      this.filter.driverMobile = '';
    },
    handleExport(type) {
      // 1导出 2小票导出
      axios
        .post(type === 1 ? api.oilgasExportOrder : api.oilgasExportOrderReceipt, { ...this.searchCache })
        .then(res => {
          this.$message.success('提交成功，请稍后在“下载管理”中查看');
        });
    }
  }
};
</script>
